import React, { useEffect, useMemo } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";



interface Props {
  fileUrl?: string | null;
  file?: File | null;
  isOpen: boolean;
  onClose: () => void;
}


const FilePreviewModal: React.FC<Props> = ({
  file,
  fileUrl,
  isOpen,
  onClose,
}) => {
  const resolvedUrl = useMemo(() => {
    if (file) return URL.createObjectURL(file);
    if (fileUrl) return fileUrl;
    return null;
  }, [file, fileUrl]);

  useEffect(() => {
    if (!file) return;

    return () => {
      if (resolvedUrl) {
        URL.revokeObjectURL(resolvedUrl);
      }
    };
  }, [file, resolvedUrl]);

  if (!resolvedUrl) return null;

  const mimeType =
    file?.type ??
    (resolvedUrl.toLowerCase().endsWith(".pdf")
      ? "application/pdf"
      : "image");

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="lg" centered scrollable backdrop="static"
      className="common_modal">
      <ModalHeader toggle={onClose} className="p-3">File Preview</ModalHeader>

      <ModalBody className="w-100">
        {mimeType.startsWith("image") && (
          <img
            src={resolvedUrl}
            className="img-fluid rounded w-100"
            alt="Preview"
          />
        )}

        {mimeType === "application/pdf" && (
          <iframe
            src={resolvedUrl}
            width="100%"
            height="500px"
            style={{ border: "none" }}
            title="PDF Preview"
          />
        )}
      </ModalBody>

       <ModalFooter className="bg-white border-top">
        <Button color="secondary" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};


export default FilePreviewModal;
